import React from 'react';
import { isString, isUndefined } from 'lodash';

const getAriaChecked = (checked: any) =>
  isString(checked) ? checked : `${!!checked}`;

const getTabIndexFromProps = (props: any) => {
  const { disabled, tabIndex } = props;

  if (disabled) {
    return undefined;
  }

  if (isUndefined(tabIndex)) {
    return 0;
  }

  return tabIndex;
};

const propsForRoles = {
  checkbox: (props: any) => ({
    'aria-checked': getAriaChecked(props.checked),
  }),
};

const addPropsForRole = (role: any, props: any) =>
  role in propsForRoles
    ? { ...props, ...(propsForRoles as any)[role](props) }
    : props;

const AccessibleElement = ({ tag, domRef, ...props }: any) => {
  if (!props.onClick) {
    return React.createElement(tag, props);
  }

  const tabIndex = getTabIndexFromProps(props);
  const onClick = props.disabled ? null : props.onClick;
  const role = isUndefined(props.role) ? 'button' : props.role;
  return React.createElement(
    tag,
    addPropsForRole(role, {
      ...props,
      tabIndex,
      onClick,
      role,
      'aria-disabled': props.disabled,
      ref: domRef,
    })
  );
};

export default AccessibleElement;

AccessibleElement.Anchor = (props: any) => {
  if (!props.href && props.onClick) {
    const style =
      props.style && typeof props.style.cursor === 'undefined'
        ? { ...props.style, cursor: 'pointer' }
        : {
            cursor: 'pointer',
          };
    return <AccessibleElement tag="a" {...props} style={style} />;
  }

  return <AccessibleElement tag="a" {...props} />;
};

AccessibleElement.Div = (props: any) => (
  <AccessibleElement tag="div" {...props} />
);

AccessibleElement.Span = (props: any) => (
  <AccessibleElement tag="span" {...props} />
);

AccessibleElement.Heading1 = (props: any) => (
  <AccessibleElement tag="h1" {...props} />
);

AccessibleElement.Heading2 = (props: any) => (
  <AccessibleElement tag="h2" {...props} />
);

AccessibleElement.Heading3 = (props: any) => (
  <AccessibleElement tag="h3" {...props} />
);

AccessibleElement.Header = (props: any) => (
  <AccessibleElement tag="header" {...props} />
);

AccessibleElement.ListItem = (props: any) => (
  <AccessibleElement tag="li" {...props} />
);
